/* ============================================================
   OSZEA — Our Story section interactions
   Vanilla JS, no dependencies. Safe to load once theme-wide.
   Self-initialises and re-inits on Shopify theme-editor section load.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    root = root || document;
    if (root.querySelector && !root.matches && !root.querySelector('.oszea-os')) {
      // 'root' is a plain document; find sections below
    }
    var scopes = (root.querySelectorAll ? root.querySelectorAll('.oszea-os') : []);
    if (root.classList && root.classList.contains('oszea-os')) scopes = [root];
    Array.prototype.forEach.call(scopes, function (scope) { initScope(scope); });
  }

  function initScope(scope) {
    if (scope.__osInit) return;
    scope.__osInit = true;
    var $ = function (s, c) { return (c || scope).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || scope).querySelectorAll(s)); };

    /* ---------- Scroll reveal ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      $$('.reveal').forEach(function (el) { io.observe(el); });
    } else {
      $$('.reveal').forEach(function (el) { el.classList.add('in'); });
    }

    /* ---------- Belief giant-word entrance ---------- */
    var belief = $('.oszea-story-belief');
    if (belief) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es, obs) {
          es.forEach(function (e) { if (e.isIntersecting) { belief.classList.add('in'); obs.disconnect(); } });
        }, { threshold: 0.3 }).observe(belief);
      } else { belief.classList.add('in'); }
    }

    /* ---------- Name reveal: draw connecting thread + tap-to-flip ---------- */
    (function () {
      var sec = $('.oszea-story-name'), line = $('.osn-line', sec);
      if (sec && line && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es, obs) {
          es.forEach(function (e) { if (e.isIntersecting) { line.classList.add('draw'); obs.disconnect(); } });
        }, { threshold: 0.35 }).observe(sec);
      } else if (line) { line.classList.add('draw'); }
      $$('.osn-part[data-flip]').forEach(function (p) {
        p.addEventListener('click', function () { p.classList.toggle('flip'); });
      });
    })();

    /* ---------- Journey: rail fills + dots light on scroll ---------- */
    (function () {
      var track = $('[data-journey]'), fill = $('[data-journey-fill]', track);
      var steps = track ? $$('.osj-step', track) : [];
      if (!track || !fill || !steps.length) return;
      var mobile = function () { return window.matchMedia('(max-width: 860px)').matches; };
      function update() {
        var r = track.getBoundingClientRect(), vh = window.innerHeight;
        var prog = (vh * 0.7 - r.top) / (r.height + vh * 0.2);
        prog = Math.max(0, Math.min(1, prog));
        if (mobile()) { fill.style.setProperty('--jh', (prog * 100) + '%'); fill.style.width = '100%'; }
        else { fill.style.width = (prog * 100) + '%'; }
        var litCount = Math.round(prog * steps.length + 0.15);
        steps.forEach(function (st, i) { st.classList.toggle('lit', i < litCount); });
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    })();

    /* ---------- Problem cards: tap-to-flip on touch ---------- */
    $$('.osp-card[data-reveal-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        if (window.matchMedia('(hover: none)').matches) card.classList.toggle('flip');
      });
    });

    /* ---------- Sticky story progress (built from sections present) ---------- */
    (function () {
      var prog = $('[data-story-prog]');
      if (!prog) return;
      var sections = $$('[data-prog]');
      if (!sections.length) { prog.style.display = 'none'; return; }
      var darkClasses = ['oszea-story-hero', 'oszea-story-cities', 'oszea-story-journey', 'oszea-story-belief', 'oszea-story-final'];
      prog.innerHTML = '';
      sections.forEach(function (sec, i) {
        var a = document.createElement('a');
        a.href = '#' + sec.id;
        a.className = 'sp-dot' + (i === 0 ? ' active' : '');
        a.innerHTML = '<span class="sp-lab">' + (sec.getAttribute('data-prog') || '') + '</span>';
        a.addEventListener('click', function (e) {
          e.preventDefault();
          sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
        });
        prog.appendChild(a);
      });
      var dots = $$('.sp-dot', prog);
      function isDark(sec) { return darkClasses.some(function (c) { return sec.classList.contains(c); }); }
      if ('IntersectionObserver' in window) {
        var spy = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            var idx = sections.indexOf(e.target);
            dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
            var dark = isDark(e.target);
            dots.forEach(function (d) { d.classList.toggle('on-dark', dark); });
          });
        }, { threshold: 0.5, rootMargin: '-20% 0px -40% 0px' });
        sections.forEach(function (sec) { spy.observe(sec); });
      }
      var hero = sections[0];
      window.addEventListener('scroll', function () {
        prog.classList.toggle('show', window.pageYOffset > (hero ? hero.offsetHeight * 0.5 : 400));
      }, { passive: true });
    })();

    /* ---------- Parallax ---------- */
    if (!reduce) {
      var pItems = $$('[data-parallax]');
      if (pItems.length) {
        var ticking = false;
        var frame = function () {
          var vh = window.innerHeight;
          pItems.forEach(function (el) {
            var r = el.getBoundingClientRect();
            if (r.bottom < -200 || r.top > vh + 200) return;
            var amt = parseFloat(el.getAttribute('data-parallax')) || 0.1;
            var center = r.top + r.height / 2 - vh / 2;
            el.style.transform = 'translate3d(0,' + (-center * amt) + 'px,0)';
          });
          ticking = false;
        };
        window.addEventListener('scroll', function () {
          if (!ticking) { ticking = true; requestAnimationFrame(frame); }
        }, { passive: true });
        frame();
      }
    }

    /* ---------- Community: mobile quote carousel dots ---------- */
    (function () {
      var track = $('[data-quote-track]'), dotWrap = $('[data-quote-dots]');
      if (!track || !dotWrap) return;
      var slides = $$('.osm-car-slide', track);
      dotWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Quote ' + (i + 1));
        if (i === 0) b.classList.add('active');
        b.addEventListener('click', function () {
          slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
        dotWrap.appendChild(b);
      });
      var dots = $$('button', dotWrap);
      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / (track.scrollWidth / slides.length));
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      }, { passive: true });
    })();

    /* ---------- Rain canvases ---------- */
    $$('[data-rain]').forEach(function (c) {
      var kind = c.getAttribute('data-rain');
      initRain(c, kind === 'belief' ? { count: 70, color: '95,200,194' } : { count: 80, color: '180,215,225' });
    });
  }

  /* rain effect (shared) */
  function initRain(canvas, opts) {
    if (!canvas || reduce || !canvas.getContext) return;
    opts = opts || {};
    var ctx = canvas.getContext('2d');
    var host = canvas.parentElement;
    var W = 0, H = 0, dpr = 1, drops = [], running = false, inView = false;
    var COUNT = opts.count || 90, COLOR = opts.color || '160,205,215';
    function resize() {
      dpr = Math.min(2, window.devicePixelRatio || 1);
      var r = host.getBoundingClientRect(); W = r.width; H = r.height;
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function seed() {
      drops = [];
      for (var i = 0; i < COUNT; i++) drops.push({ x: Math.random() * W, y: Math.random() * H, len: 9 + Math.random() * 16, v: 6 + Math.random() * 8, a: 0.06 + Math.random() * 0.16 });
    }
    function loop() {
      ctx.clearRect(0, 0, W, H); ctx.lineWidth = 1.1;
      for (var i = 0; i < drops.length; i++) {
        var d = drops[i];
        ctx.strokeStyle = 'rgba(' + COLOR + ',' + d.a + ')';
        ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x - 1.5, d.y + d.len); ctx.stroke();
        d.y += d.v; d.x -= 0.4;
        if (d.y > H) { d.y = -d.len; d.x = Math.random() * W; }
      }
      if (inView) requestAnimationFrame(loop); else running = false;
    }
    function start() { if (!running) { running = true; requestAnimationFrame(loop); } }
    resize(); seed();
    window.addEventListener('resize', function () { resize(); seed(); }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { inView = e.isIntersecting; if (inView) start(); });
      }, { threshold: 0.02 }).observe(host);
    } else { inView = true; start(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }

  // Theme editor: re-init when a section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
